import React from 'react';
import appTypes from '../../../../constants/types';
import SectionCard from '../../../../components/section-card';
import { TextDataField } from '../../../../components/data-fields';

export const ResetIAMUserPasswordDetails = ({ ticket }) => (
  <SectionCard title="IAM User">
    <TextDataField
      name="IAM User"
      value={ticket && ticket.ticket_data.iam_user} />
  </SectionCard>
);

ResetIAMUserPasswordDetails.propTypes = {
  ticket: appTypes.ticket.props,
};
ResetIAMUserPasswordDetails.defaultProps = {
  ticket: appTypes.ticket.default,
};
